module.exports = __webpack_public_path__ + "img/course_Image_one.9325b095.png";